import { BrowserRouter as Router, Routes, Route, unstable_HistoryRouter as HistoryRouter, Navigate, useNavigate, useLocation, Outlet } from "react-router-dom";
import { USER, VENDOR, ADMIN, PARTNERS } from "shared/Roles";
import FrontRouter from "./FrontRouter";
import VendorRouter from "./VendorRouter";
import AdminRouter from "./AdminRouter";
import PartnersRouter from "./PartnersRouter";

function RootRouter(props) {
    return (
        <Routes>
            <Route path={"/*"} element={<FrontRouter />} />
            <Route path={"/partners/*"} element={<PartnersRouter />} />
            <Route path={"/vendor/*"} element={<VendorRouter allowedRoles={[VENDOR, ADMIN]} />} />
            <Route path={"/admin/*"} element={<AdminRouter allowedRoles={[ADMIN, PARTNERS]} />} />
        </Routes>
    );
}

export default RootRouter;